import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from '../core/services/login.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  authenticationError: boolean = false;

  logging: boolean = false;

  loginForm: FormGroup = this.formBuilder.group({
    username: null,
    password: null
  });

  constructor(private route: ActivatedRoute, private formBuilder: FormBuilder, private router: Router, private service: LoginService) { }

  ngOnInit(): void {
    const token: string = this.route.snapshot.params['token'];
    if (token) {
      this.service.onLoginSuccess(token);
      return;
    }

    if (this.service.isAuthenticated()) {
      this.navigateToDashboard();
    }
  }

  login() {
    this.logging = true;
    this.service.login({
      USERNAME: this.loginForm.get('username')!.value,
      PASSWORD: this.loginForm.get('password')!.value
    }).subscribe(
      () => {
        this.authenticationError = false;
        this.navigateToDashboard();
      },
      () => {
        this.authenticationError = true;
        this.logging = false;
      }
    );
  }

  redirectToSsoUrl() {
    window.location.href = this.service.getSsoLoginUrl();
  }

  private navigateToDashboard() {
    this.router.navigate(['/dashboard']);
  }

}
